import type { Languages } from '../../types/common';

type Translations = Record<Languages, Record<string, string>>;

export const TRANSLATIONS: Translations = {
  en: {
    'search-placeholder': 'Search ArchDaily'
  },
  es: {
    'search-placeholder': 'Buscar en ArchDaily'
  },
  pt: {
    'search-placeholder': 'Buscar en ArchDaily'
  },
  zh: {
    'search-placeholder': '搜索ArchDaily'
  }
}
